import React from "react";

//interfaces
import { IAppContent } from "../../../interfaces/mobileAppPreview/mobileAppPreview";

//components
import { IconLibrary, ThriveIcon } from "../..";
import { getImageAsset } from "../../../helpers/Images";




const AppContent = ({appContent}:IAppContent) => {

    if (!appContent?.length) {
        return (
            <div className="loading-app-preview-content-wrapper">
                <ThriveIcon 
                    iconName={IconLibrary.THRIVE} 
                    color="var(--thriveChalk)"
                    sizeInPx={"40"}
                />
            </div>
        )
    }

    return (
        <div className="app-preview-content-wrapper">
            <div className="hero-content-item">
                <div key={0} className="content-item">
                    <img src={getImageAsset(239, appContent[0].featuredImageUrl)} alt={appContent[0].title} />
                    
                    <div className="overlay">
                        <h2 className="hero-content-title">{appContent[0].title}</h2>
                    </div>
                </div>
            </div>

            <div className="grid">
                {appContent.slice(1).map((item, index) => (
                    <div key={index} className="content-item">
                        <img src={getImageAsset(113, item.featuredImageUrl)} alt={item.title} />
                        
                        <div className="overlay">
                            <h3 className="content-title">{item.title}</h3>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AppContent;
